module.exports = __webpack_public_path__ + "img/s00144.5edcbacc.jpg";